import { useState, useEffect } from 'react';
import api from './api';

export function Settings() {
    const [users, setUsers] = useState([]);
    const [newPasswords, setNewPasswords] = useState({});

    const load = () => {
        api.get('/users').then((res) => setUsers(res.data));
    };

    useEffect(() => { load(); }, []);

    const changeRole = async (id, role) => {
        await api.put(`/users/${id}`, { role });
        load();
    };

    const resetPassword = async (id) => {
        const password = newPasswords[id];
        if (!password) return;
        await api.put(`/users/${id}/password`, { password });
        setNewPasswords({ ...newPasswords, [id]: '' });
        alert('Password updated');
    };

    const deleteUser = async (id) => {
        await api.delete(`/users/${id}`);
        load();
    };

    return (
        <div className="settings-page">
            <h2>Settings</h2>
            <h3>Users</h3>
            <div className="users-list">
                {users.map((u) => (
                    <div key={u.id} className="user-row">
                        <span>{u.username}</span>
                        <select value={u.role} onChange={(e) => changeRole(u.id, e.target.value)}>
                            <option value="user">User</option>
                            <option value="admin">Admin</option>
                        </select>
                        <input
                            type="password"
                            placeholder="New password"
                            value={newPasswords[u.id] || ''}
                            onChange={(e) => setNewPasswords({ ...newPasswords, [u.id]: e.target.value })}
                        />
                        <button onClick={() => resetPassword(u.id)}>Reset Password</button>
                        <button onClick={() => deleteUser(u.id)}>Delete User</button>
                    </div>
                ))}
            </div>
        </div>
    );
}
